import moment from "moment";
import http, { host } from "./httpService";

// Master

export const sendEmailToJD = async (msg) => {
  const formData = new FormData();
  formData.append("Message", msg);
  return await http.post(host + "SendEmailContainerbooking_AB", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const getPortList = async (
  searchString,
  requestCancelToken,
  setRequestCancelToken
) => {
  if (requestCancelToken) {
    requestCancelToken.cancel("Operation canceled due to new request.");
  }
  let temp = http.CancelToken.source();
  setRequestCancelToken(temp);

  const response = await http.get(host + "GetPODMaster", {
    params: { inputStr: searchString, PageNumber: 1, PageSize: 40000 },
    cancelToken: temp.token,
  });
  return response;
};

export const requestCountries = async (
  searchString,
  requestCancelToken,
  setRequestCancelToken
) => {
  if (requestCancelToken) {
    requestCancelToken.cancel("Operation canceled due to new request.");
  }
  let temp = http.CancelToken.source();
  setRequestCancelToken(temp);

  const response = await http.get(host + "GetCountryMaster", {
    params: { countrybyName: searchString, PageNumber: 1, PageSize: 40000 },
    cancelToken: temp.token,
  });
  return response;
};

export const getTransporterList = async () => {

  const response = await http.get(host + "GetAllTranspoterDetails");
  return response;
};

export const GetMailRecepients = async () => {
  const response = await http.get(host + "GetMailRecepients");
  return response;
};

export const getCountryList = async (
  searchString,
  requestCancelToken,
  setRequestCancelToken
) => {
  if (requestCancelToken) {
    requestCancelToken.cancel("Operation canceled due to new request.");
  }
  let temp = http.CancelToken.source();
  setRequestCancelToken(temp);

  const response = await http.get(host + "GetCountryMaster", {
    params: { CountrybyName: searchString, PageNumber: 1, PageSize: 40000 },
    cancelToken: temp.token,
  });
  return response;
};

export const getJDCalendarDatesOfMonth = async (month) => {
  return await http.get(host + "GetJDMonthDateList", {
    params: {
      jdMonth: moment(month).format("MMM-YY"),
      PageNumber: 1,
      PageSize: 40,
    },
  });
};

export const getReportForUser = async (month) => {
  return await http.get(host + "GetDashBoardList", {
    params: { PlanningMonth: month },
  });
};

export const getAllModuleShipmentList = async  (data) => {
  return await http.get(host + "GetShipmentForMail", {
    params: { date: data },
  })
}

export const getAllModuleReportData = async  (data) => {
  return await http.get(host + "GetShipmentReport", {
    params: { fromdate: data.fromDate, todate: data.toDate },
  })
}

export const viewDoc = async (data) => {
  return await http.get(host + `ViewAbFile?FileName=${data}`)
}

export const getCarrierAllocation = async (month, country) => {
  return await http.get(host + `GetAbCarrierAllocationData`,{params:{JDMonth : month, CountryName : country}})
  // return await http.get(host + `GetAbCarrierAllocationData?JDMonth=${month}&CountryName=${country}`)
}

export const getContainerCount = async (month) => {
  return await http.get(host + "GetStatusWiseConCount_Aryabhatta", {params:{JDMonth : month}})
}

export const updateCarrierAllocationTEUs = async (data) => {
  return await http.put(host + 'UpdateCarrierAllocation_AB', data)
}

// export const carrierAllocationMappedService = (data) => {
//   var finalData = []
//   for (let i = 0; i < data.length; i++) {
//     finalData.push({
//       ...data[i],
//       Carriers:data[i]["AllCarrier"].split(","),
//       CarriersLimitValue:data[i]["LimtForCarriers"].split(","),
//       maerskColor:(data[i]["LimtForCarriers"].split(",")[0] > data[i]["Count_For_Mearsk"])?"green":"red",
//       hapagColor:(data[i]["LimtForCarriers"].split(",")[1] > data[i]["Count_For_HAPAG"])?"green":"red",
//       OOCLColor:(data[i]["LimtForCarriers"].split(",")[2] > data[i]["Count_For_OOCL"])?"green":"red",
//       CMAColor:(data[i]["LimtForCarriers"].split(",")[3] > data[i]["Count_For_CMA_CGM"])?"green":"red",
//     })
//   }
//   return finalData;
// }

export const getUserAccessDataService = async (data) => {
  return await http.get(host + `GetLoginUserAccess`,{params:data})
}

export const invPackingDocValidation = async (id, type) => {
  return await http.get(host + `AryabhattInvoiceDocValidation`,{params:{ContainerMasterId : id, DataOf : type}})
}
export const ChangeContainerDiversion = async (data) => {
  await http.post(host + "CreateContainerDiversionAll_Aryabhatta", {_jsonCntDivAllAryalist:data})
}
export const getConatinerData = async (data) => {
 return await http.post(host + "GetContainerDiversionData_Aryabhata", {_jsonCntDivDataAryalist:data})
  
}
export const getContainerDiversionData = async (data) => {
    return await http.post(
        host + "GetContainerDiversionData",
        data
    );
};

export const Updatecontainerdiversion = async (payload) => {
  return await http.put(host + "UpdateContainerDiversionData_Aryabhatta",payload)
 }
export const passcodeRequest = async (emailID) => {
  return await http.post(
    host + "ForgotpasswordRequest",
    {
      EmailID: emailID,
    }
  );
};

export const requestNewPassword = async (payload) => {
  return await http.post(host + "Changeforgotpassword", payload);
};

